export enum NavigationType {
  HEAD = 'head',
  SUBHEAD = 'subhead'
}
